import { axiosAjax } from '@app/src/config/axios';
import { hydrateOperator } from './hydrators';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { getSettings } from '@app/src/configuration/config.service';

export const serviceOperator = {
  async getData(url: string, refreshToken?: string) {
    try {
      let token = refreshToken ? refreshToken : sessionStorage.getItem('accessToken');
      const idService = decodeAccessToken('idService');
      const { data } = await axiosAjax.get(url.replace(':id', idService.toString()), {
        headers: { Authorization: `Bearer ${token}` }
      });
      return hydrateOperator(data);
    } catch(e) {
      throw e.response.data;
    }
  }
};

export const serviceRefreshToken = {
  async getData(refreshToken: string) {
    try {
      const expToken = sessionStorage.getItem('accessToken');
      const { data, headers } = await axiosAjax.post(getSettings().API_REFRESH_TOKEN, { refreshToken, expToken });
      const refreshtoken = headers.authorization;
      localStorage.setItem('refreshtoken', refreshtoken);
      if(data.code == 100){
        sessionStorage.setItem('accessToken', data.data.accessToken);
        sessionStorage.setItem('reportToken', data.data.reportToken);
        return data;
      }else{
        throw new Error(data.message);
      }
    } catch (e) {
      throw e.response.data;
    }
  }
}
